import { apiSlice } from "../../app/apiSlice";
import { withDefaultMeta } from "../../util/withDefaultMeta";

export const productApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => {
    const query = withDefaultMeta(builder.query);
    const mutation = withDefaultMeta(builder.mutation);

    return {
      // 🔹 Public routes
      getProducts: query({
        query: () => "/products",
        providesTags: ["Product"],
        meta: { requiresAuth: false },
      }),

      getProductById: query({
        query: (id) => `/products/${id}`,
        providesTags: (result, error, id) => [{ type: "Product", id }],
        meta: { requiresAuth: false },
      }),

      // 🔹 Admin routes
      createProduct: mutation({
        query: (newProduct) => ({
          url: "/products",
          method: "POST",
          body: newProduct,
        }),
        invalidatesTags: ["Product"],
      }),

      updateProduct: mutation({
        query: ({ id, ...updates }) => ({
          url: `/products/${id}`,
          method: "PUT",
          body: updates,
        }),
        invalidatesTags: (result, error, { id }) => [
          { type: "Product", id },
          "Product",
        ],
      }),

      unlinkProductVideo: builder.mutation({
        query: ({ productId }) => ({
          url: `/products/${productId}/unlink-videos`,
          method: "POST",
        }),
        invalidatesTags: (result, error, arg) => [
          { type: "Product", id: arg.productId },
          { type: "Video", id: "LIST" },
        ],
      }),

      deleteProduct: mutation({
        query: ({ id }) => ({
          url: `/products/${id}`,
          method: "DELETE",
        }),
        invalidatesTags: (result, error, id) => [
          { type: "Product", id },
          "Product",
        ],
      }),
    };
  },
});

export const {
  useGetProductsQuery,
  useGetProductByIdQuery,
  useCreateProductMutation,
  useUpdateProductMutation,
  useDeleteProductMutation,
  useUnlinkProductVideoMutation,
} = productApiSlice;
